import { Grid, TextField, Typography } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { useForm } from "react-hook-form";
import React, { useState, useEffect } from 'react';
import UpdateCancel from "../../atoms/buttons/UpdateCancel";
import { invokeGetService, invokePostService } from '../../../store/global/actions'
import LoaderWithProgress from '../../atoms/loader/LoaderWithProgress';
import Alert from '@material-ui/lab/Alert/Alert';


export default function EditProfile({ onClose, onCompletion, profileId, item, setAction }) {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [isFetching, setIsFetching] = useState(false);
    const { register, handleSubmit, formState: { errors }, reset, setError } = useForm({});
    const [profile, setProfile] = useState(undefined);
    useEffect(() => {
        if (profileId) {
            setIsFetching(true);
            dispatch(invokeGetService('getClusterlet', [profileId])).then(res => {
                if (res?.status == true) {
                    setProfile(res.data);
                    reset({
                        name: res?.data?.name,
                        description: res?.data?.attributes?.desc
                    });
                } else {
                    if (res?.code === 255) {
                        onClose();
                    }
                }
                setIsFetching(false);
            });
        }
    }, [])



    const onUpdate = ({ description }) => {
        setLoading(true);
        const clusterlet = {
            attributes: {
                ...profile.attributes,
                desc: description
            }
        }
        dispatch(invokePostService('editClusterlet', { clusterlet }, [profileId])).then(res => {
            setLoading(false);
            if (res?.status === true) {
                onCompletion('Profile', 'edit', errors, undefined);
            } else {
                if (res?.code === process.env.REACT_APP_FORM_ERROR_CODE) {
                    res?.errors.forEach(error => {
                        setError(error.name, { message: error.message });
                    });
                }
                if (res?.code === 255) {
                    onClose();
                }
            }
        });
    }




    return (
        <> {
            profileId ?
                isFetching === true ?
                    <LoaderWithProgress size={20} isContent={true} styleRoot={{ marginTop: '30vh' }} />
                    :
                    <Grid container direction={"row"} spacing={3}>
                        <Grid item xs={12}>
                            <Typography >Edit profile</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                name="name"
                                fullWidth
                                autoFocus
                                type={"text"}
                                label={"Name"}
                                placeholder={""}
                                variant="outlined"
                                disabled={true}
                                inputRef={register({ required: true })}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                id="description"
                                type={"text"}
                                fullWidth
                                rows={4}
                                label={"Description"}
                                placeholder={"Description"}
                                variant="outlined"
                                name="description"
                                inputRef={register({ required: false })}
                                multiline
                                minRows={2}
                            />
                        </Grid>


                        <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end", marginBottom: 20 }} >
                            <UpdateCancel onUpdate={handleSubmit(onUpdate)} updateDisable={loading} content={loading ? 'Updating' : 'Update'} onCancel={onClose} typesNotIn={['transaction', 'view']} />
                        </Grid>
                    </Grid>
                :
                <Grid>
                    <Alert severity="info" style={{ marginTop: "0.6rem" }}>
                        Please create a section first to start with
                    </Alert>

                </Grid>
        }
        </>
    )
}